export const MODAL_ID = 'activate-deals-terms';
